import { useMemo } from "react";
import {
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Typography,
} from "@mui/material";
import Battery5BarIcon from "@mui/icons-material/Battery5Bar";
import DeviceThermostatIcon from "@mui/icons-material/DeviceThermostat";
import EventIcon from "@mui/icons-material/Event";
import Grid from "@mui/material/Grid2";
import MaterialUiButton from "../Buttons/MaterialUiButton/MaterialUiButton";

// This component has a css file you can use to get ride of the borders of Googles Info window component.
// To enable the css, the parent of the map component needs to have the className "custom-css"

export default function PopUpMarkerContent(props) {
  const {
    buttonLabel = "SUBMIT",
    clickedFacility = false,

    // Having the facility object here allows us to say something like.. "The asset you clicked is in this facility"
    facility = {},

    item = {},
    onButtonClick = () => {},

    // This is silly. But we got new requirements
    onButtonClick2 = () => {},
    onNavigateButtonClick = () => {},
  } = props;
  const {
    assetTag = null, //for snapshot
    event = null,
    facility: facilityFromAsset = "N/A",
    lastEvent = null,
    string = "N/A",
    tag = null,
  } = item;
  const { name: facilityName = "" } = facility;
  // We currently do not know how this mechanism works or if the final product will have this. So we are faking this out for now.
  const fakeBatteryLevel = useMemo(
    () => Math.floor(Math.random() * 100) + 1,
    []
  );
  const fakeTemparature = useMemo(
    () => Math.floor(Math.random() * 100) + 1,
    []
  );

  if (clickedFacility) {
    return (
      <Grid
        className="map-info-window"
        container
        sx={{
          backgroundColor: "white",
          minHeight: "10rem",
          maxWidth: "40vw",
          padding: "1rem",
          position: "relative",
        }}
      >
        {/* Top 25% red background overlay */}
        <Grid
          item
          sx={{
            background:
              "linear-gradient(to bottom, #32355C, rgba(255, 255, 255, 0.1))", // Gradient from #32355C to a slight white
            height: "30%",
            left: 0,
            position: "absolute", // Overlay it on top
            top: 0,
            width: "100%",
            zIndex: 1, // Ensure it sits behind everything
          }}
        />

        {/* Name of Facilities */}
        <Grid
          container
          sx={{
            backgroundColor: "white",
            minHeight: "5rem",
            maxWidth: "40vw",
            padding: "1rem",
          }}
        >
          <Typography variant="h4">{facilityName}</Typography>
        </Grid>

        {/* Details */}
        {Object.values(item).length === 0 ? null : (
          <Grid item size={12}>
            <Typography variant="body1">
              <strong>{tag}</strong>
              {` is in this facility. Click the button below to see exact location.`}
            </Typography>
          </Grid>
        )}

        {/* Button */}
        <Grid
          item
          size={12}
          sx={{
            marginBottom: ".5rem",
            marginTop: ".5rem",
          }}
        >
          <MaterialUiButton
            color="submit"
            fullWidth
            label={buttonLabel}
            onClick={onButtonClick}
            sx={{ fontSize: "14px" }}
            variant="text"
          />
        </Grid>

        {/* Click here to navigate to the Facility */}
        <Grid item size={12}>
          <MaterialUiButton
            color="submit"
            fullWidth
            label="Navigate to Facility"
            onClick={() => {
              onNavigateButtonClick(facility);
            }}
            sx={{ fontSize: "14px" }}
            variant="text"
          />
        </Grid>

        {/* View Asset History Button */}
        {Object.values(item).length !== 0 ? (
          <Grid
            item
            size={12}
            sx={{
              marginBottom: ".5rem",
              marginTop: ".5rem",
            }}
          >
            <MaterialUiButton
              color="submit"
              fullWidth
              label="View Asset History"
              onClick={onButtonClick2}
              sx={{ fontSize: "14px" }}
              variant="text"
            />
          </Grid>
        ) : null}
      </Grid>
    );
  }

  return (
    <Grid
      className="map-info-window"
      container
      sx={{
        backgroundColor: "white",
        minHeight: "10rem",
        maxWidth: "20rem",
        padding: ".75rem",
        position: "relative",
      }}
    >
      {/* Top 25% red background overlay */}
      <Grid
        item
        sx={{
          background:
            "linear-gradient(to bottom, #32355C, rgba(255, 255, 255, 0.1))", // Gradient from #32355C to a slight white
          // borderRadius: '1rem 1rem 0 0', // Optional: rounded corners
          height: "30%",
          left: 0,
          position: "absolute", // Overlay it on top
          top: 0,
          width: "100%",
          zIndex: 1, // Ensure it sits behind everything
        }}
      />

      {/* Asset Tag / City state */}
      <Grid
        item
        size={10}
        sx={{
          backgroundColor: "#f5f5f5",
          // marginTop: '.5rem',
          zIndex: 2,
        }}
      >
        <Card>
          <CardContent
            sx={{
              paddingBottom: ".5rem !important",
              padding: ".5rem",
            }}
          >
            <Grid container>
              <Grid item size={12} sx={{ textAlign: "left" }}>
                <Typography
                  noWrap
                  variant="h5"
                  sx={{ textDecoration: "underline" }}
                >
                  {tag || assetTag || "N/A"}
                </Typography>
                <Typography variant="caption">
                  {facilityFromAsset}, {string}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      {/* List of items */}
      <Grid item size={12}>
        <List sx={{ paddingBottom: 0 }}>
          {/* Last Event */}
          <ListItem sx={{ minWidth: "fit-content", padding: "0 16px" }}>
            <ListItemAvatar>
              <EventIcon />
            </ListItemAvatar>
            <ListItemText
              primary={`Last Event: ${lastEvent || event || "N/A"}`}
            />
          </ListItem>

          {/* Battery Life */}
          <ListItem sx={{ padding: "0 16px" }}>
            <ListItemAvatar>
              <Battery5BarIcon />
            </ListItemAvatar>
            <ListItemText primary={`Battery Life: ${fakeBatteryLevel}%`} />
          </ListItem>

          {/* Temp */}
          <ListItem sx={{ padding: "0 16px" }}>
            <ListItemAvatar>
              <DeviceThermostatIcon />
            </ListItemAvatar>
            <ListItemText primary={`Temperature: ${fakeTemparature}`} />
          </ListItem>
        </List>
      </Grid>

      {/* Button */}
      <Grid
        item
        size={12}
        sx={{
          marginBottom: ".5rem",
          marginTop: ".5rem",
        }}
      >
        <MaterialUiButton
          color="submit"
          fullWidth
          label={buttonLabel}
          onClick={onButtonClick}
          sx={{ fontSize: "14px" }}
          variant="text"
        />
      </Grid>

      {/* Click here to navigate to the asset */}
      <Grid item size={12}>
        <MaterialUiButton
          color="submit"
          fullWidth
          label="Navigate to Asset"
          onClick={() => {
            onNavigateButtonClick(item);
          }}
          sx={{ fontSize: "14px" }}
          variant="text"
        />
      </Grid>
    </Grid>
  );
}
